import BiotechIcon from "@mui/icons-material/Biotech";
import GroupsIcon from "@mui/icons-material/Groups";
import MedicationIcon from "@mui/icons-material/Medication";
import ScienceIcon from "@mui/icons-material/Science";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import FadeInComponent from "./FadeInComponent";
import SectionWrapper from "./SectionWrapper";
import React from "react";

const colors = [
  "#FF6B6B",
  "#45B7D1",
  "#fa8e63",
  "#6ac3cf",
  "#F7DC6F",
  "#BB8FCE",
  "#85C1E2",
];

const iconMap = [ScienceIcon, BiotechIcon, MedicationIcon, GroupsIcon];

export default function ServicesSection() {
  const theme = useTheme();

  const serviceItems = [
    {
      title: "Excellence Scientifique",
      text: "Développer des données scientifiques selon les plus hautes normes internationales de qualité",
    },
    {
      title: "Innovation Moléculaire",
      text: "Collaborer au développement de nouvelles molécules dans les études cliniques de phases 2, 3 et 4",
    },
    {
      title: "Accès Thérapeutique",
      text: "Offrir aux patients un accès encadré à des thérapies novatrices avant leur commercialisation",
    },
    {
      title: "Accompagnement Patients",
      text: "Assurer un accompagnement exceptionnel dans l'initiation et le suivi des nouveaux traitements",
    },
  ];

  return (
    <Box>
      <SectionWrapper>
        <Box
          id="services-section"
          sx={{
            display: "flex",
            flexDirection: "column",
            scrollMarginTop: "calc(var(--header-height, 80px) - 40px)",
          }}
        >
          <FadeInComponent>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", lg: "row" },
                alignItems: "flex-start",
                gap: { xs: 4, lg: 12 },
                mb: { xs: 6, lg: 8 },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  color: theme.palette.text.secondary,
                  mb: { xs: 1, lg: 0 },
                  whiteSpace: { lg: "nowrap" },
                  flex: 1,
                  maxWidth: { xs: "100%", lg: "35%" },
                  textTransform: "uppercase",
                  letterSpacing: 1.5,
                }}
              >
                Nos services
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  textAlign: "justify",
                  color: theme.palette.grey[500],
                  flex: 1,
                  maxWidth: { xs: "100%", lg: "60%" },
                }}
              >
                La mission du Centre de recherche en rhumatologie GRMO est de
                contribuer activement à l'avancement des connaissances et à
                l'amélioration des soins en rhumatologie, en s'appuyant sur une
                recherche clinique rigoureuse, humaine et innovante.
              </Typography>
            </Box>
          </FadeInComponent>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
                "@media (min-width: 1700px)": {
                  gridTemplateColumns: "repeat(4, 1fr)",
                },
              },
              gap: { xs: 3, md: 4 },
              width: "100%",
            }}
          >
            {serviceItems.map((item, index) => {
              return (
                <FadeInComponent key={index} delay={index * 0.1}>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      gap: 0,
                      background: theme.palette.common.white,
                      px: { xs: 3, md: 4 },
                      py: { xs: 2, md: 3 },
                      borderRadius: 2,
                    }}
                  >
                    {React.createElement(iconMap[index % iconMap.length], {
                      sx: {
                        fontSize: theme.typography.h1.fontSize,
                        color: colors[index % colors.length],
                        mb: { xs: 1, sm: 1.5, "@media (min-width: 1700px)": 1 },
                      },
                    })}
                    <Typography
                      variant="h5"
                      sx={{
                        color: theme.palette.grey[400],
                        pb: { xs: 1, sm: 1.5, "@media (min-width: 1700px)": 1 },
                        borderBottom: `1px solid ${theme.palette.grey[600]}`,
                        minHeight: "5rem",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        pt: { xs: 1, sm: 1.5, "@media (min-width: 1700px)": 1 },
                        color: theme.palette.grey[400],
                      }}
                    >
                      {item.text}
                    </Typography>
                  </Box>
                </FadeInComponent>
              );
            })}
          </Box>
        </Box>
      </SectionWrapper>
    </Box>
  );
}
